import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import question from "@/assets/images/question.svg";
import { getDrmPfInformation } from "@/api/drmPfInformation";
import { useLoadingStore } from "@/stores/loading";
import * as Common from "@/utils/common";
import { DrmPfInformation } from "@/types/drmPfInformation";
import { useDrmPfInformationSearch } from "@/stores/drmPfInformationSearch";
import {useDrmPfInformationFont} from "@/utils/useDrmPfInformationFont";
import exclamation from '@/assets/images/exclamation.svg'
import {CustomMarkdown} from "@/components/CustomMarkdown";

export default function DrmPfInformationDetail() {
  const navigate = useNavigate();
  useDrmPfInformationFont();
  const setLoading = useLoadingStore(state => state.setLoading);
  const { backPage } = useDrmPfInformationSearch();
  const drmPfInformationId = Number(useParams().id);
  const [drmPfInformation, setDrmPfInformation] = useState<DrmPfInformation>()

  const onClickBack = () => {
    navigate(backPage);
  };

  useEffect(() => {
    setLoading(true)
    getDrmPfInformation(drmPfInformationId).then(result => {
      setDrmPfInformation(result.data)
    }).catch(error => {
    }).finally(() => {
      setLoading(false)
    })
  }, [])

  return (
    <div className="uk-flex uk-flex-column uk-flex-middle">
      <div className="sub-header">
        <p className="uk-text-large uk-text-bold uk-margin-remove">
          お知らせ一覧
        </p>
      </div>
      <div className="uk-width-3-4 uk-margin-top">
        <div className="uk-flex uk-flex-middle">
          <img src={exclamation} alt=""/>
          <p className="uk-text-medium uk-text-bold uk-margin-small-left">
            お知らせ
          </p>
        </div>
        <div className="padding-20 uk-flex background-gray243 uk-margin-top">
          <div>
            <p className="uk-text-large-l uk-text-bold">{drmPfInformation?.title}</p>
          </div>
        </div>
        <div className="uk-flex uk-margin-top uk-margin-left">
          <div>
            <p className="uk-text-medium-s">
              <CustomMarkdown content={drmPfInformation?.body}/>
            </p>
            <div className="uk-flex uk-flex-between uk-margin-top">
              <div className="uk-flex">
                <div className="uk-flex uk-flex-middle width-175">
                  <p className="tag-dark">管理番号</p>
                  <p className="uk-text-default margin-left-16">{Common.controlNum(drmPfInformationId)}</p>
                </div>
                <div className="uk-flex uk-flex-middle width-175">
                  <p className="tag-dark">公開日</p>
                  <p className="uk-text-default margin-left-27">{drmPfInformation?.release_date}</p>
                </div>
              </div>
              <div className="uk-flex uk-flex-wrap gap-10 uk-margin-small-right">
                <p className="tag-light">{drmPfInformation?.drm_pf_information_type.name}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="uk-flex uk-flex-center uk-margin-large">
          <button className="button-dark" onClick={onClickBack}>
            一覧へ戻る
          </button>
        </div>
      </div>
    </div>
  );
}

